import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiTaskToCompleteTabsEnum } from '@fi-shared/fi-task-shared/fi-task-to-complete-tabs.enum';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-task-navigation-tabs',
    template: `
        <fi-navigation-tabs
          [tabsModel]="tabs"
          [selectedIndex]="selectedIndex"
          (selectedIndexChange)="onTabIndexChange($event)"
          >
          <ng-container ngProjectAs="header-right-content">
            <div class="ccm-page-header-button-group right-aligned">
              @if (tabs[selectedIndex].AddState) {
                <button
                  mat-raised-button
                  class="BrandedBackgroundColor fi-header-button"
                  [fiStateSref]="tabs[selectedIndex].AddState"
                  >
                  <span class="fas fa-plus"></span>
                </button>
              }
            </div>
          </ng-container>
        </fi-navigation-tabs>
        `,
    styleUrls: ['./task-navigation-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-navigation-tabs' },
    standalone: false,
})
export class TaskNavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.tabs.push({
            Title: this.appTextService.get('task.to_be_done'),
            Sref: FiStateNames.Task.ToComplete,
            SrefParams: {
                tabNumber: FiTaskToCompleteTabsEnum.AssignedToMe,
            },
            AddState: FiStateNames.Task.Add,
        });

        this.tabs.push({
            Title: this.appTextService.get('common.completed'),
            Sref: FiStateNames.Task.Completed,
            SrefParams: {
                tabNumber: FiTaskToCompleteTabsEnum.AssignedToMe,
            },
        });

        this.tabs.push({
            Title: this.appTextService.get('task.status_and_followup'),
            Sref: FiStateNames.Task.Status,
        });

        this.tabs.push({
            Title: this.appTextService.get('task.archived_tasks'),
            Sref: FiStateNames.Task.Archived,
        });

        super.updateSelectedTabFromState();
    }
}
